import React from 'react';
import { Redirect } from 'react-router-dom';

import {
  Home,
  // AboutThis,
  NotFound,
  ConfirmSignupEmail,
  ResendConfirmSignupEmail,
  Signup,
  Login,
  // Welcome,
  // Profile,
  Settings,
  TwitterCallback,
} from 'pages';

// TODO(tyu):
// Actually, define /a/<component> and switch component dynamically


/*
 * `guard` props for DecoratedRoute
 *  TODO(t10u): Move below out of routes.js
 */
const isLoggedIn = ({ sessionState: ss }) => Boolean(ss.get('jwt'));
const isNotLoggedIn = (props) => !isLoggedIn(props);
const redirectToHome = (props) => <Redirect to={{ pathname: '/' }} />;
const redirectToLogin = (props) => <Redirect to={{ pathname: '/login' }} />;


const guestOnly = {
  guard: {
    ensure: isNotLoggedIn,
    otherwise: redirectToHome,
  },
};

const loggedInOnly = {
  guard: {
    ensure: isLoggedIn,
    otherwise: redirectToLogin,
  },
};


// XXX(thx): Comment out all the routes for preview for now..
/*
 * Non React Router keys:
 * - redirect: String, path to redirect to.
 * - guard: Object, with two defined keys: ensure, otherwise
 * - premount: Array, actions to dispatch before mount.
 */
const routes = [
  // TODO: change the name to HomeSwitch to explicitly show dynamic component
  {path: '/', exact: true, component: Home},
  // {path: '/about', exact: true, redirect: '/about/this'},
  // {path: '/about/this', exact: true, component: AboutThis},

  {path: '/login', exact: true, component: Login, ...guestOnly},
  {path: '/signup', exact: true, component: Signup, ...guestOnly},
  {path: '/a/confirm/signup-email', exact: true,
    component: ConfirmSignupEmail, ...guestOnly},
  {path: '/a/resend/confirm-signup-email', exact: true,
    component: ResendConfirmSignupEmail, ...guestOnly},

  {path: '/a/oauth/twitter/callback', exact: true, component: TwitterCallback},

  // Welcome will redirect back to home, if not for a new sign up
  // {path: '/welcome', exact: true, component: Welcome},

  {path: '/settings', component: Settings, ...loggedInOnly,
    premount: [
      // TODO: To be implemented / tested.
    ],
  },

  // {path: '/draft', component: XYZ},

  // Reference: https://github.com/pillarjs/path-to-regexp#usage
  // {path: '/:atSymbol(@)?:handle', exact: true, component: Profile},

  {component: NotFound},
];


export default routes;



// WEBPACK FOOTER //
// ./src/routes.js